import { selectIcon, SVG } from "../components/UI/selector";
import BackgroundImageDark from "../assets/Images/InternalBackgroundDark.png";
import { env } from "./CommonFunction";

export const staticVar = {
  version: "1.2.1",
  scheduled: "SCHEDULED",
  waitingRoom: "IN_WAITING_ROOM",
  roomStarted: "STARTED",
  waiting: "WAITING",
  hangoutRoom: "IN_HANGOUT_ROOM",
  ended: "ENDED",
  oneDay: "ONE_DAY",
  daily: "DAILY",
  weekly: "WEEKLY",
  customDay: "CUSTOM_RECURRENCE",
  liveWorkoutPathName: "/LiveActivity",
  manualUpload: "manual-upload",
  bulkUpload: "bulk-upload",
  schedulePasswordProtected: "PASSWORD_PROTECTED",
  public: "PUBLIC",
  mindbody: "mindbody",
  marianatek: "marianatek",
  tribe: "tribe",
  Activity: "Class",
  activity: "class",
  Activities: "Classes",
  activities: "classes",
  bulkDownload:
    "https://tribe-static-content-files.s3.amazonaws.com/whitelabel/Template.csv",
  accessToken: undefined,
  textMsg: "We are using your web's camera and mic",
  permission: true,
};

const setColorData = (el, themeData) => {
  document.documentElement.style.setProperty(el.name, themeData[el.value]);
  /* setTimeout(() => {
    themeColor[el.value] = getComputedStyle(
      document.documentElement
    ).getPropertyValue(el.name)
  }, 100) */
};

export const setColor = (themeData) => {
  //Brand Colors, Different for all studios
  [
    { name: "--theme-color", value: "theme" },
    { name: "--color-primary", value: "primaryColor" },
    { name: "--color-tertiory", value: "secondaryColor" },
    { name: "--color-secondary", value: "tertioryColor" },
    { name: "--color-on-primary", value: "primaryTextColor" },
    //Currently this color is not right, we will set it to white temporirly
    //{ name: "--color-on-secondary", value: "secondaryTextColor" },
    { name: "--box-border-color", value: "boxBorderColor" },
    //Use this only in light versions, on dark version we set seperately
    { name: "--layer1", value: "layerOne" },
    { name: "--bg-translucent", value: "backgroundColor" },
    { name: "--color-background", value: "background" },
  ].forEach((el) => {
    setColorData(el, themeData);
  });
  /*
   * Values for dark are already set by default in index.scss
   * Replace values for light themes
   */
  if (themeData["theme"] === "light") {
    document.documentElement.style.setProperty("--text", "#505050");
    document.documentElement.style.setProperty("--sub-text", "#828282");
    document.documentElement.style.setProperty("--icon", " #828282");
    document.documentElement.style.setProperty("--icon-bg", " #e5e5e5");
    document.documentElement.style.setProperty("--heart-icon", " #828282");
    document.documentElement.style.setProperty(
      "--layer1-stroke",
      " var(e5e5e5)"
    );
    document.documentElement.style.setProperty("--layer2", " #ededed");
    document.documentElement.style.setProperty("--layer3", " #cdcdcd");
    document.documentElement.style.setProperty("--layer-forth", "#a6a6a6");
    document.documentElement.style.setProperty("--top-bar", "#ffffff");
    document.documentElement.style.setProperty("--top-bar-stroke", "#e5e5e5");
    document.documentElement.style.setProperty("--dropdown", "#505050");
    document.documentElement.style.setProperty("--disabled", "#767676");
    //set bg image url variable
    document.documentElement.style.setProperty("--bg-image-url", "");
  } else {
    //Use this color for layer 1 in dark mode
    document.documentElement.style.setProperty("--layer1", "#ffffff14");
    document.documentElement.style.setProperty(
      "--bg-image-url",
      "url(" + BackgroundImageDark + ")"
    );
  }
  document.documentElement.style.setProperty("--color-on-secondary", "#ffffff");
};

export const getAppNameFromURL = () => {
  const subDomain = window.location.hostname.split(".")[0];
  switch (subDomain) {
    case "thebeat-member":
    case "dev-thebeat-member":
      return "theBeat";
    default:
      return "tribe";
  }
};

export const getWhiteLabelData = () => {
  const appName = getAppNameFromURL();
  const appID = env("appID")[appName];
  const isWhiteLabeled = appName !== "tribe";
  return {
    isWhiteLabeled,
    appName: appName,
    appID: isWhiteLabeled ? appID : "TRIBE",
  };
};

export const themeData = {
  gympasslive: {
    theme: "light",
    primaryColor: "#D8385E",
    secondaryColor: "#FFFFFF",
    tertioryColor: "#FF4438",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#505050",
    boxBorderColor: "#A6A6A6",
    layerOne: "#E5E5E533",
    backgroundColor: "rgba(229, 229, 229, 0.6)",
    background: "#FFFFFF",
  },
  orangeTheory: {
    theme: "light",
    primaryColor: "#ED700F",
    secondaryColor: "#FFFFFF",
    tertioryColor: "#075D7E",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#505050",
    boxBorderColor: "#A6A6A6",
    layerOne: "#E5E5E533",
    backgroundColor: "rgba(229, 229, 229, 0.6)",
    background: "#FFFFFF",
  },
  theBeat: {
    theme: "light",
    primaryColor: "#595BAF",
    secondaryColor: "#FFFFFF",
    tertioryColor: "#63BCC9",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#505050",
    boxBorderColor: "#A6A6A6",
    layerOne: "#E5E5E533",
    backgroundColor: "rgba(229, 229, 229, 0.6)",
    background: "#FFFFFF",
  },
  theUnion: {
    theme: "dark",
    primaryColor: "#DFFF00",
    secondaryColor: "#424242",
    tertioryColor: "#3EC70B",
    primaryTextColor: "#222222",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#767676",
    layerOne: "#222222",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    background: "#222222",
  },
  upBeat: {
    theme: "light",
    primaryColor: "#ED2126",
    secondaryColor: "#FAF7F5",
    tertioryColor: "#F8ACB6",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#505050",
    boxBorderColor: "#A6A6A6",
    layerOne: "#E5E5E533",
    backgroundColor: "rgba(229, 229, 229, 0.6)",
    background: "#FFFFFF",
  },
  kerrySports: {
    theme: "dark",
    primaryColor: "#E7E347",
    secondaryColor: "#424242",
    tertioryColor: "#3AB4F2",
    primaryTextColor: "#222222",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#767676",
    layerOne: "#222222",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    background: "#222222",
  },
  upState: {
    theme: "dark",
    primaryColor: "#F7DD5E",
    secondaryColor: "#424242",
    tertioryColor: "#D61C4E",
    primaryTextColor: "#222222",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#767676",
    layerOne: "#222222",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    background: "#222222",
  },
  YFN: {
    theme: "dark",
    primaryColor: "#E35F21",
    secondaryColor: "#424242",
    tertioryColor: "#017A95",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#767676",
    layerOne: "#222222",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    background: "#222222",
  },
  swyftSweat: {
    theme: "dark",
    primaryColor: "#4F14FF",
    secondaryColor: "#767676",
    tertioryColor: "#AABDFF",
    primaryTextColor: "#222222",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#767676",
    layerOne: "#222222",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    background: "#222222",
  },
  woodsFit: {
    theme: "dark",
    primaryColor: "#FF6700",
    secondaryColor: "#424242",
    tertioryColor: "#F79500",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#767676",
    layerOne: "#222222",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    background: "#222222",
  },
  sweatShop: {
    theme: "dark",
    primaryColor: "#A5C439",
    secondaryColor: "#424242",
    tertioryColor: "#39174B",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#767676",
    layerOne: "#222222",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    background: "#222222",
  },
  plyGrd: {
    theme: "dark",
    primaryColor: "#51AE6C",
    secondaryColor: "#424242",
    tertioryColor: "#844B28",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#767676",
    layerOne: "#222222",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    background: "#222222",
  },
  barrys: {
    theme: "dark",
    primaryColor: "#D61638",
    secondaryColor: "#424242",
    tertioryColor: "#D61638",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#767676",
    layerOne: "#222222",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    background: "#222222",
  },
  f45digital: {
    theme: "light",
    primaryColor: "#211551",
    secondaryColor: "#FFFFFF",
    tertioryColor: "#D6001C",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#505050",
    boxBorderColor: "#A6A6A6",
    layerOne: "#E5E5E533",
    backgroundColor: "rgba(229, 229, 229, 0.6)",
    background: "#FFFFFF",
  },
  soulcycleDigital: {
    theme: "dark",
    primaryColor: "#FFDE00",
    secondaryColor: "#424242",
    tertioryColor: "#FFDE00",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#A6A6A6",
    layerOne: "#E5E5E533",
    backgroundColor: "rgba(12, 12, 12, 0.5)",
    background: "#FFFFFF",
  },
  therippleclub: {
    theme: "light",
    primaryColor: "#52C6D8",
    secondaryColor: "#D9CEB4",
    tertioryColor: "#D9CEB4",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#505050",
    boxBorderColor: "#A6A6A6",
    layerOne: "#E5E5E533",
    backgroundColor: "rgba(229, 229, 229, 0.6)",
    background: "#FFFFFF",
  },
  tribe: {
    theme: "dark",
    primaryColor: "#F22B5D",
    secondaryColor: "#424242",
    tertioryColor: "#594AD7",
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#FFFFFF",
    boxBorderColor: "#767676",
    layerOne: "#222222",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    background: "#222222",
  },
};

export const defaultValue = {
  limit: 4,
  height: "calc((100% - 30px) / 3)",
  width: "calc((100% - 75px) / 4)",
};

export const activityType1 = [
  {
    icon: selectIcon("dance"),
    name: "Dance",
    value: "Dance",
    child: ["Pole", "Aerial", "Zumba", "Aero Dance"],
  },
  {
    icon: selectIcon("cardio"),
    name: "Cardio",
    value: "Cardio",
    child: [
      "Running",
      "Walking",
      "Rowing",
      "Tread",
      "Jump Rope",
      "Swimming",
      "TABATA",
    ],
  },
  {
    icon: selectIcon("mobility"),
    name: "Mobility",
    value: "Mobility",
    child: [],
  },
  {
    icon: selectIcon("streching"),
    name: "Stretching",
    value: "Stretching",
    child: [],
  },
  {
    icon: selectIcon("meditation"),
    name: "Meditation",
    value: "Meditation",
    child: [],
  },
  {
    icon: selectIcon("yoga"),
    name: "Yoga",
    value: "Yoga",
    child: [
      "Vinyasa",
      "Restorative",
      "Prenatal",
      "Postnatal",
      "Slow Flow",
      "Ashtanga",
      "Power Yoga",
    ],
  },
  { icon: selectIcon("pilates"), name: "Pilates", value: "Pilates", child: [] },
  { icon: selectIcon("barre"), name: "Barre", value: "Barre", child: [] },
  {
    icon: selectIcon("bootcamp"),
    name: "Bootcamp",
    value: "Bootcamp",
    child: [],
  },
  {
    icon: selectIcon("boxing"),
    name: "Boxing",
    value: "Boxing",
    child: ["Kickboxing", "MMA", "Total-Body", "Shadow Boxing"],
  },
  { icon: selectIcon("sports"), name: "Sports", value: "Sports", child: [] },
  {
    icon: selectIcon("celebrity"),
    name: "Celebrity",
    value: "Celebrity",
    child: [],
  },
  { icon: selectIcon("core"), name: "Core", value: "Core", child: [] },
  { icon: selectIcon("cycling"), name: "Cycling", value: "Cycling", child: [] },
  { icon: selectIcon("hiit"), name: "HIIT", value: "HIIT", child: [] },
  {
    icon: selectIcon("seniorFitness"),
    name: "Senior Fitness",
    value: "Senior Fitness",
    child: [],
  },
  {
    icon: selectIcon("strengths"),
    name: "Strength",
    value: "Strength",
    child: [],
  },
  {
    icon: selectIcon("calisthenics"),
    name: "Calisthenics",
    value: "Calisthenics",
    child: [],
  },
  {
    icon: selectIcon("functional"),
    name: "Functional",
    value: "Functional",
    child: [],
  },
  { icon: selectIcon("toning"), name: "Toning", value: "Toning", child: [] },
  { icon: selectIcon("other"), name: "Others", value: "Others", child: [] },
];
/***old**/
export const version = "0.0.1";

export const specialities = [
  { name: "Yoga", image: selectIcon("userDummy"), id: 0 },
  { name: "HIIT", image: selectIcon("userDummy"), id: 1 },
  { name: "Martial Arts", image: selectIcon("userDummy"), id: 2 },
  { name: "Running", image: selectIcon("userDummy"), id: 3 },
  { name: "Pilates", image: selectIcon("userDummy"), id: 4 },
  { name: "Boxing", image: selectIcon("userDummy"), id: 5 },
  { name: "Sports", image: selectIcon("userDummy"), id: 6 },
  { name: "Medication", image: selectIcon("userDummy"), id: 7 },
  { name: "Barre", image: selectIcon("userDummy"), id: 8 },
  { name: "Bootcamp", image: selectIcon("userDummy"), id: 9 },
  { name: "Rowing", image: selectIcon("userDummy"), id: 10 },
  { name: "Cycling", image: selectIcon("userDummy"), id: 11 },
  { name: "Dance", image: selectIcon("userDummy"), id: 12 },
  { name: "Outdoors", image: selectIcon("userDummy"), id: 13 },
  { name: "Elliptical", image: selectIcon("userDummy"), id: 14 },
  { name: "Prenatal", image: selectIcon("userDummy"), id: 15 },
  { name: "Spinning", image: selectIcon("userDummy"), id: 16 },
  { name: "Core", image: selectIcon("userDummy"), id: 17 },
];

export const activityType = [
  { name: "Dance", value: "Dance" },
  { name: "Spinning", value: "Spinning" },
  { name: "Cardio", value: "Cardio" },
  { name: "Strength", value: "Strength" },
  { name: "Interval Training", value: "Interval Training" },
  { name: "Martial Arts", value: "Martial Arts" },
  { name: "Mobility", value: "Mobility" },
  { name: "Stretching", value: "Stretching" },
  { name: "Meditation", value: "Meditation" },
  { name: "Yoga", value: "Yoga" },
  { name: "Pilates", value: "Pilates" },
  { name: "Barre", value: "Barre" },
  { name: "Sports", value: "Sports" },
  { name: "Pole and Aerial Arts", value: "Pole and Aerial" },
  { name: "Celebrity", value: "Celebrity" },
  { name: "Others", value: "Others" },
  { name: "Bootcamp", value: "Bootcamp" },
  { name: "Calisthenics", value: "Calisthenics" },
  { name: "Functional", value: "Functional" },
];

export const difficultyLevel = [
  { icon: selectIcon("low"), name: "Beginner", value: "BEGINNER" },
  { icon: selectIcon("medium"), name: "Intermediate", value: "INTERMEDIATE" },
  { icon: selectIcon("high"), name: "Advanced", value: "ADVANCED" },
];

export const privacy_settings = [
  { name: "Public", value: "PUBLIC" },
  { name: "Member Only", value: "MEMBERS_ONLY" },
  { name: "Private", value: "PASSWORD_PROTECTED" },
];

export const dateStatusOption = [
  { name: "Created On", value: "created_at" },
  { name: "Edited On", value: "updated_at" },
  { name: "Last Used On", value: "last_used_at" },
];

export const activitySetup = [
  { name: "Studio Only (No Video)", value: "PHYSICAL" },
  { name: "Online (With Video)", value: "ONLINE" },
  { name: "Hybrid (In Studio & Online)", value: "HYBRID" },
];

export const booleanCondition = [
  { name: "Yes", value: true },
  { name: "No", value: false },
];

export const equipment = [
  { name: "Mat", value: "Mat" },
  { name: "Dumbbell", value: "Dumbbell" },
  { name: "Kettlebell", value: "Kettlebell" },
  { name: "Barbell", value: "Barbell" },
  { name: "Mobility Stick", value: "Mobility Stick" },
  { name: "Weight Plates", value: "Weight Plates" },
  { name: "Pilates Ring", value: "Pilates Ring" },
  { name: "Yoga Brick", value: "Yoga Brick" },
  { name: "Foam Roller", value: "Foam Roller" },
  { name: "Massage Ball", value: "Massage Ball" },
  { name: "Massage Bar", value: "Massage Bar" },
  { name: "Stability Ball", value: "Stability Ball" },
  { name: "BOSU Ball", value: "BOSU Ball" },
  { name: "Exercise Bike", value: "Exercise Bike" },
  { name: "Treadmill", value: "Treadmill" },
  { name: "Bodyweight", value: "Bodyweight" },
  { name: "Cables", value: "Cables" },
  { name: "Weights Machine", value: "Weights Machine" },
  { name: "Suspension", value: "Suspension" },
  { name: "Airex", value: "Airex" },
  { name: "Wobble Board", value: "Wobble Board" },
  { name: "Plate", value: "Plate" },
  { name: "Leg Weights", value: "Leg Weights" },
  { name: "Weighted Vest", value: "Weighted Vest" },
  { name: "Dyna Disc", value: "Dyna Disc" },
  { name: "Battle Rope", value: "Battle Rope" },
  { name: "Sandbag", value: "Sandbag" },
  { name: "Resistance Bands", value: "Resistance Bands" },
  { name: "Gliding Disc", value: "Gliding Disc" },
  { name: "Power Wheel", value: "Power Wheel" },
  { name: "Ab Wheel", value: "Ab Wheel" },
  { name: "Medicine Ball", value: "Medicine Ball" },
  { name: "Elliptical", value: "Elliptical" },
  { name: "Rowing Machine", value: "Rowing Machine" },
  { name: "Stairclimber", value: "Stairclimber" },
  { name: "Step Board", value: "Step Board" },
  { name: "Plyo Box", value: "Plyo Box" },
  { name: "Drumstick", value: "Drumstick" },
  { name: "Push Up Bar", value: "Push Up Bar" },
  { name: "Pull Up Bar", value: "Pull Up Bar" },
  { name: "Exercise Bench", value: "Exercise Bench" },
  { name: "Weighted Hoop", value: "Weighted Hoop" },
  { name: "ViPR", value: "ViPR" },
  { name: "Agility Ladder", value: "Agility Ladder" },
  { name: "Agility Box", value: "Agility Box" },
  { name: "Hurdles", value: "Hurdles" },
  { name: "Agility Cones", value: "Agility Cones" },
  { name: "Balance Pad", value: "Balance Pad" },
  { name: "Jump Rope", value: "Jump Rope" },
  { name: "Reaction Ball", value: "Reaction Ball" },
  { name: "Reaction Bell", value: "Reaction Bell" },
  { name: "Heavy Bag", value: "Heavy Bag" },
  { name: "Atlas Stones", value: "Atlas Stones" },
  { name: "Bolsters", value: "Bolsters" },
  { name: "Blankets", value: "Blankets" },
  { name: "Chair", value: "Chair" },
  { name: "Dip bar", value: "Dip bar" },
  { name: "Gymnastic Rings", value: "Gymnastic Rings" },
  { name: "Sleds", value: "Sleds" },
  { name: "Speed Bag", value: "Speed Bag" },
  { name: "Tires", value: "Tires" },
  { name: "Weighted Gloves", value: "Weighted Gloves" },
  { name: "Wrist Weights", value: "Wrist Weights" },
  { name: "Y-bell", value: "Y-bell" },
  { name: "Yoga Belt", value: "Yoga Belt" },
  { name: "Yoga Wheel", value: "Yoga Wheel" },
];

export const timeDuration = [
  { name: 15, value: 15 },
  { name: 30, value: 30 },
  { name: 45, value: 45 },
  { name: 60, value: 60 },
  { name: 75, value: 75 },
];

export const chartData = [
  {
    datums: [
      { x: "0", y: 0, r: undefined },
      { x: "1", y: 9, r: undefined },
      { x: "2", y: 72, r: undefined },
      { x: "3", y: 63, r: undefined },
      { x: "4", y: 6, r: undefined },
      { x: "5", y: 20, r: undefined },
      { x: "6", y: 54, r: undefined },
      { x: "7", y: 57, r: undefined },
      { x: "8", y: 27, r: undefined },
      { x: "9", y: 35, r: undefined },
      { x: "10", y: 63, r: undefined },
      { x: "11", y: 6, r: undefined },
      { x: "12", y: 20, r: undefined },
      { x: "13", y: 54, r: undefined },
      // {x: "14", y: 27, r: undefined},
      // {x: "15", y: 35, r: undefined},
      // {x: "16", y: 63, r: undefined},
      // {x: "17", y: 20, r: undefined},
      // {x: "18", y: 54, r: undefined},
      // {x: "19", y: 57, r: undefined},
      // {x: "20", y: 27, r: undefined},
      // {x: "21", y: 35, r: undefined},
      // {x: "22", y: 63, r: undefined},
      // {x: "23", y: 74, r: undefined},
      // {x: "24", y: 74, r: undefined},
      // {x: "25", y: 63, r: undefined},
      // {x: "26", y: 74, r: undefined},
      // {x: "27", y: 74, r: undefined},
      // {x: "28", y: 74, r: undefined},
      // {x: "29", y: 74, r: undefined},
      // {x: "30", y: 27, r: undefined},
      // {x: "31", y: 35, r: undefined},
      // {x: "32", y: 63, r: undefined},
      // {x: "33", y: 74, r: undefined},
      // {x: "34", y: 35, r: undefined},
      // {x: "35", y: 63, r: undefined},
      // {x: "36", y: 74, r: undefined},
      // {x: "37", y: 35, r: undefined},
      // {x: "38", y: 63, r: undefined},
      // {x: "39", y: 74, r: undefined},
      // {x: "40", y: 31, r: undefined},
      // {x: "41", y: 35, r: undefined},
      // {x: "42", y: 79, r: undefined},
      // {x: "43", y: 81, r: undefined},
      // {x: "44", y: 35, r: undefined},
      // {x: "45", y: 63, r: undefined},
      // {x: "46", y: 74, r: undefined},
      // {x: "47", y: 35, r: undefined},
      // {x: "48", y: 63, r: undefined},
      // {x: "49", y: 74, r: undefined},
      // {x: "50", y: 63, r: undefined},
      // {x: "51", y: 6, r: undefined},
      // {x: "52", y: 20, r: undefined},
      // {x: "53", y: 54, r: undefined},
      // {x: "54", y: 27, r: undefined},
      // {x: "55", y: 35, r: undefined},
      // {x: "56", y: 63, r: undefined},
      // {x: "57", y: 20, r: undefined},
      // {x: "58", y: 54, r: undefined},
      // {x: "59", y: 57, r: undefined},
      // {x: "60", y: 35, r: undefined},
      // {x: "61", y: 63, r: undefined},
      // {x: "62", y: 74, r: undefined},
      // {x: "63", y: 35, r: undefined},
      // {x: "64", y: 63, r: undefined},
      // {x: "65", y: 74, r: undefined},
      // {x: "66", y: 63, r: undefined},
      // {x: "67", y: 6, r: undefined},
      // {x: "68", y: 20, r: undefined},
      // {x: "69", y: 54, r: undefined},
      // {x: "70", y: 27, r: undefined},
      // {x: "71", y: 35, r: undefined},
      // {x: "72", y: 63, r: undefined},
      // {x: "73", y: 20, r: undefined},
      // {x: "74", y: 54, r: undefined},
      // {x: "75", y: 57, r: undefined},
      // {x: "76", y: 27, r: undefined},
      // {x: "77", y: 35, r: undefined},
      // {x: "78", y: 63, r: undefined},
      // {x: "79", y: 20, r: undefined},
      // {x: "80", y: 54, r: undefined},
      // {x: "81", y: 57, r: undefined},
      // {x: "82", y: 63, r: undefined},
      // {x: "83", y: 20, r: undefined},
      // {x: "84", y: 54, r: undefined},
      // {x: "85", y: 57, r: undefined},
      // {x: "86", y: 27, r: undefined},
      // {x: "87", y: 35, r: undefined},
      // {x: "88", y: 63, r: undefined},
      // {x: "89", y: 20, r: undefined},
      // {x: "90", y: 54, r: undefined},
      // {x: "91", y: 57, r: undefined},
      // {x: "92", y: 63, r: undefined},
      // {x: "93", y: 20, r: undefined},
      // {x: "94", y: 54, r: undefined},
      // {x: "95", y: 57, r: undefined},
      // {x: "96", y: 27, r: undefined},
      // {x: "97", y: 35, r: undefined},
      // {x: "98", y: 63, r: undefined},
      // {x: "99", y: 20, r: undefined},
      // {x: "100", y: 54, r: undefined},
      // {x: "101", y: 57, r: undefined},
      // {x: "102", y: 63, r: undefined},
      // {x: "103", y: 20, r: undefined},
      // {x: "104", y: 54, r: undefined},
      // {x: "105", y: 57, r: undefined},
      // {x: "106", y: 27, r: undefined},
      // {x: "107", y: 35, r: undefined},
      // {x: "108", y: 63, r: undefined},
      // {x: "109", y: 20, r: undefined},
      // {x: "110", y: 54, r: undefined},
      // {x: "111", y: 57, r: undefined},
      // {x: "112", y: 63, r: undefined},
      // {x: "113", y: 20, r: undefined},
      // {x: "114", y: 54, r: undefined},
      // {x: "115", y: 57, r: undefined},
      // {x: "116", y: 27, r: undefined},
      // {x: "117", y: 35, r: undefined},
      // {x: "118", y: 63, r: undefined},
      // {x: "119", y: 75, r: undefined}
    ],
    label: "Series 1",
  },
];

export const weekDays = {
  0: { day: "Mon", value: 1 },
  1: { day: "Tue", value: 2 },
  2: { day: "Wed", value: 3 },
  3: { day: "Thu", value: 4 },
  4: { day: "Fri", value: 5 },
  5: { day: "Sat", value: 6 },
  6: { day: "Sun", value: 0 },
};
export const durationKey = ["hour", "minute", "second"];

export const gender = [
  { name: "Male", value: "MALE" },
  { name: "Female", value: "FEMALE" },
  { name: "Other", value: "OTHER" },
];

export const access = {
  location: { show: false, label: "Show Location", value: true },
  classlocation: { show: false, label: "Add Location In Class", value: true },
  multiplelocation: {
    show: false,
    label: "Show Multiple Location Option In Location List",
    value: true,
  },
  switchlocation: {
    show: false,
    label: "Show Single Switch Location Option In Location List",
    value: true,
  },
  locationList: {
    show: false,
    label: "Show Location In List With filter",
    value: true,
  },
  defaultUser: { show: true, label: "Default For Class", value: false },
  isActiveAllowedForAllLocation: {
    show: false,
    label: "Allowed For All Location Key",
    value: true,
  },
  userStream: { show: false, label: "UserStream in ondemand", value: false },
};

export const location = {
  list: [],
  fetch: false,
};

export const internet = {
  offline: null,
};

export const mediaStream = {
  stream: null,
};

export const videoResolution = [
  { name: "1920X1080 (16:9)", value: { width: 1920, height: 1080 } },
  { name: "1280X720 (16:9)", value: { width: 1280, height: 720 } },
];

export const workoutData1 = {
  workout_builder: [
    {
      segment_id: "sidFYEH16781740095390000",
      segment_order: "1",
      segment_icon: "Barre",
      segment_icon_id: "null",
      segment_icon_url: "null",
      segment_icon_svg_url: "null",
      segment_name: "nbnb",
      segment_duration_in_seconds: 324,
      exercise_ids: ["eidFYEH167817400953900000"],
      is_activity_segment_separated: false,
      exercises: [
        {
          segment_id: "sidFYEH16781740095390000",
          exercise_id: "eidFYEH167817400953900000",
          exercise_name: "nnb",
          exercise_audio: [
            {
              media_id: "3e03e92e-839e-45aa-bf2a-50d00bf702f2",
              audio_url:
                "https://dev-studio-content.s3.amazonaws.com/2dabf70c-904b-4dee-8aa7-4d539399a216/media-library/audios/3e03e92e-839e-45aa-bf2a-50d00bf702f2/3e03e92e-839e-45aa-bf2a-50d00bf702f2.mp3",
              media_name: "file_example_MP3_5MG",
              audio_play_at: 60,
              audio_duration: 0,
              is_coach_muted: false,
              audio_play_duration: 144,
              is_audio_play_in_loop: true,
            },
          ],
          exercise_image: null,
          exercise_order: "1",
          exercise_video: [
            {
              media_id: "12b7ff99-be26-4f95-9490-276522817370",
              video_url:
                "https://dev-studio-content.s3.amazonaws.com/2dabf70c-904b-4dee-8aa7-4d539399a216/media-library/videos/12b7ff99-be26-4f95-9490-276522817370/hls/12b7ff99-be26-4f95-9490-276522817370/master.m3u8",
              media_name: "testing",
              video_play_at: 30,
              is_video_muted: true,
              video_duration: 0,
              video_play_duration: 240,
              is_video_play_in_loop: true,
              video_screen_location: "FULL_SCREEN",
            },
          ],
          show_countdown: true,
          show_to_participants: false,
          current_activity_status: "ON_DEMAND",
          exercise_duration_in_seconds: 324,
          is_activity_exercise_separated: false,
        },
      ],
    },
  ],
};
